




// import React, { useState } from 'react';
// import 'tachyons/css/tachyons.min.css';
// import { useNavigate } from "react-router";

// import { Icon } from "./icons.js";
// import "./styles.css";

// // --- Inline SVG Icons (replacing lucide-react) ---

// const IconShield = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
//     <path d="M9 12l2 2 4-4"/>
//   </svg>
// );

// const IconCloud = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"/>
//   </svg>
// );

// const IconBarChart = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="12" y1="20" x2="12" y2="10"/><line x1="18" y1="20" x2="18" y2="4"/>
//     <line x1="6" y1="20" x2="6" y2="16"/>
//   </svg>
// );

// const IconUsers = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
//     <circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
//     <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
//   </svg>
// );

// const IconHeadphones = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
//     <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
//   </svg>
// );

// const IconChevronDown = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="6 9 12 15 18 9"/>
//   </svg>
// );

// const IconArrowRight = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
//   </svg>
// );

// const IconMenu = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="18" x2="21" y2="18"/>
//   </svg>
// );

// const IconX = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//   </svg>
// );

// const IconCheckCircle = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
//   </svg>
// );

// const IconTrendingUp = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/>
//   </svg>
// );

// const IconMessageSquare = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
//   </svg>
// );

// const IconDollarSign = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
//   </svg>
// );

// const IconCloudOff = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26A8 8 0 1 0 3 16.29"/>
//     <line x1="1" y1="1" x2="23" y2="23"/>
//   </svg>
// );

// const IconZap = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/>
//   </svg>
// );

// const IconClock = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
//   </svg>
// );

// const IconTarget = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
//   </svg>
// );

// const IconHeartHandshake = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.002A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0 .521-2.2L12 15"/>
//     <path d="M8 15l1.535 1.535a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0 .521-2.2L12 12"/>
//     <path d="M14 9l-1 1"/><path d="M16.535 12.535L15 14"/>
//   </svg>
// );

// const IconCalendar = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/>
//     <line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/>
//   </svg>
// );

// const IconUserPlus = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="8.5" cy="7" r="4"/>
//     <line x1="20" y1="8" x2="20" y2="14"/><line x1="23" y1="11" x2="17" y2="11"/>
//   </svg>
// );

// const IconHandshake = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M20.42 4.58a5.4 5.4 0 0 0-7.65 0l-.77.78-.77-.78a5.4 5.4 0 0 0-7.65 7.65l.77.78 7.65 7.65 7.65-7.65.77-.78a5.4 5.4 0 0 0 0-7.65z"/>
//     <path d="M12 12h.01"/>
//   </svg>
// );

// const IconPhone = ({className}) => (
//   <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
//   </svg>
// );

// // Brand emerald color
// const EMERALD = '#059669';
// const EMERALD_DARK = '#047857';
// const EMERALD_LIGHT = '#d1fae5';
// const DARK_BG = '#0f172a';

// // --- Components ---

// const HeroSection = () => {
//   const navigate = useNavigate();

//   return (
//     <section className="pa3 white relative overflow-hidden" style={{backgroundColor: DARK_BG}}>
//       <div className=" center ph3 pv5 pv6-l">
//         <div className="flex flex-wrap items-center">
//           <div className="w-100 w-50-l pr4-l mb4 mb0-l">
//       <h1 className="f2 f1-l fw7 lh-title mb3" style={{color: '#34d399'}}>About TerraWeb</h1>
//             <h1 className="f2 f1-l fw7 lh-title mb3">
//               Building Digital Infrastructure<br/>for Stronger Cooperatives
//             </h1>
//             <p className="white-70 f5 lh-copy mb4" style={{maxWidth: '480px'}}>
//               TerraWeb empowers agricultural societies, cooperatives, and organizations with connected tools to manage operations, engage members, and make data-driven decisions.
//             </p>
//             <div className="flex flex-wrap mb4">
//               <button onClick={() => navigate("/contactus")} className="white pv3 ph4 br2 f6 fw5 mr3 mb2 bn pointer flex items-center" style={{backgroundColor: EMERALD}}>
//                 Request Demo <IconArrowRight className="w1 h1 ml2"/>
//               </button>
//               <button onClick={() => navigate("/")} className="white-80 ba b--white-30 pv3 ph4 br2 f6 fw5 mb2 bn pointer bg-transparent">
//                 Explore Platform
//               </button>
//             </div>
//             <div className="flex items-center">
//               {/* <div className="flex mr3">
//                 {[1,2,3,4,5].map(i => (
//                   <div key={i} className="w2 h2 br-100 ba b--dark-gray flex items-center justify-center f7 white mr1" style={{backgroundColor: '#4b5563', marginLeft: i > 1 ? '-8px' : '0', zIndex: 6-i, position: 'relative'}}>
//                     {String.fromCharCode(64 + i)}
//                   </div>
//                 ))}
//               </div> */}
//               <p className="white-60 f6">Trusted by forward-thinking organizations</p>
//             </div>
//           </div>

//           <div className="w-100 w-50-l flex justify-center justify-end-l">
//             <div className="bg-white br3 shadow-4 overflow-hidden" style={{maxWidth: '520px', width: '100%'}}>
//               <div className="flex">
//                 {/* <div className="w-40 bg-light-gray pa3 dn db-ns" style={{backgroundColor: '#f9fafb', minWidth: '140px'}}>
//                    <div className="flex items-center mb4">
//                     <div className="w1 h1 br1 flex items-center justify-center mr2" style={{backgroundColor: EMERALD}}>
//                       <svg viewBox="0 0 24 24" className="w-75 h-75 white" fill="currentColor"><path d="M12 2L2 7l10 5 10-5-10-5z"/></svg>
//                     </div>
//                     <span className="f6 fw6 dark-gray">TerraWeb</span>
//                   </div> 
//                   <div className="flex flex-column">
//                     {['Dashboard','Collections','Members','Finance','Messaging','Reports','Settings'].map((item, idx) => (
//                       <div key={item} className={`flex items-center pa2 mb1 br2 f7 ${idx === 0 ? 'white' : 'gray'}`} style={idx === 0 ? {backgroundColor: EMERALD} : {}}>
//                         <div className="w1 h1 mr2 br1" style={{backgroundColor: idx === 0 ? 'rgba(255,255,255,0.3)' : '#e5e7eb'}}></div>
//                         {item}
//                       </div>
//                     ))}
//                   </div> 
//                 </div> */}

//                 <div className="w-60 pa3" style={{backgroundColor: '#f8f9fa', flex: 1}}>
//                   <div className="flex justify-between items-center mb3">
//                     <span className="f5 fw6 dark-gray">Dashboard</span>
//                     <div className="flex items-center">
//                       <div className="w2 h2 br-100 flex items-center justify-center f7 fw6 mr2" style={{backgroundColor: EMERALD_LIGHT, color: EMERALD}}>JW</div>
//                       <div className="dn db-ns">
//                         <p className="f7 fw5 dark-gray mb0">Jane Wanjiku</p>
//                         <p className="f7 gray mt0">Admin</p>
//                       </div>
//                     </div>
//                   </div>

//                   <div className="flex flex-wrap justify-between mb3">
//                     {[
//                       {label: 'Total Farmers', val: '2,450'},
//                       {label: 'Collections (Today)', val: '8,750 L'},
//                       {label: 'Total Payouts', val: 'KES 1.2M'},
//                       {label: 'Active Cooperatives', val: '32'}
//                     ].map(stat => (
//                       <div key={stat.label} className="bg-white br2 pa2 mr2 mb2" style={{minWidth: '70px', flex: '1 1 45%'}}>
//                         <div className="f7 gray mb1">{stat.label}</div>
//                         <div className="f6 fw6 dark-gray">{stat.val}</div>
//                       </div>
//                     ))}
//                   </div>

//                   <div className="bg-white br2 pa3 mb3">
//                     <div className="flex justify-between mb2">
//                       <span className="f7 fw6 dark-gray">Collection Overview</span>
//                       <div className="flex">
//                         <span className="f7 gray mr2 flex items-center"><span className="w1 h1 br-100 dib mr1" style={{backgroundColor: EMERALD}}></span> Milk</span>
//                         <span className="f7 gray flex items-center"><span className="w1 h1 br-100 dib mr1" style={{backgroundColor: '#60a5fa'}}></span> Coffee</span>
//                       </div>
//                     </div>
//                     <svg viewBox="0 0 300 80" className="w-100" style={{height: '60px'}}>
//                       <path d="M0,60 Q30,50 60,55 T120,40 T180,45 T240,30 T300,35" fill="none" stroke={EMERALD} strokeWidth="2"/>
//                       <path d="M0,65 Q30,60 60,62 T120,55 T180,58 T240,50 T300,52" fill="none" stroke="#60a5fa" strokeWidth="2"/>
//                     </svg>
//                     <div className="flex justify-between mt1">
//                       {['Mon','Tue','Wed','Thu','Fri','Sat','Sun'].map(d => (
//                         <span key={d} className="f7 gray">{d}</span>
//                       ))}
//                     </div>
//                   </div>

//                   <div className="flex justify-between">
//                     <div className="bg-white br2 pa2 mr2" style={{width: '48%'}}>
//                       <div className="f7 fw6 dark-gray mb2">Payout Summary</div>
//                       <div className="flex items-center">
//                         <svg viewBox="0 0 60 60" width="40" height="40">
//                           <circle cx="30" cy="30" r="25" fill="none" stroke="#e5e7eb" strokeWidth="6"/>
//                           <circle cx="30" cy="30" r="25" fill="none" stroke={EMERALD} strokeWidth="6" strokeDasharray="60 100" transform="rotate(-90 30 30)"/>
//                           <circle cx="30" cy="30" r="25" fill="none" stroke="#60a5fa" strokeWidth="6" strokeDasharray="30 100" strokeDashoffset="-60" transform="rotate(-90 30 30)"/>
//                         </svg>
//                         <div className="ml2">
//                           <div className="f7 gray">KES 1,250,000</div>
//                           <div className="f7 gray">KES 850,000</div>
//                         </div>
//                       </div>
//                     </div>
//                     <div className="bg-white br2 pa2" style={{width: '48%'}}>
//                       <div className="f7 fw6 dark-gray mb2">Top Cooperatives</div>
//                       {['Kagumo Dairy Cooperative', 'Mutha Farmers Society', 'The Future Cooperative'].map((name, i) => (
//                         <div key={name} className="flex items-center mb1">
//                           <div className="w1 h1 br-100 mr2" style={{backgroundColor: i === 0 ? EMERALD : i === 1 ? '#60a5fa' : '#9ca3af'}}></div>
//                           <span className="f7 gray truncate">{name}</span>
//                         </div>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const TrustBadges = () => {
//   const badges = [
//     {icon: IconShield, title: 'Secure & Reliable', desc: 'Enterprise-grade security to protect your data'},
//     {icon: IconCloud, title: 'Accessible Anywhere', desc: 'Works on mobile and web, online or offline'},
//     {icon: IconBarChart, title: 'Real-time Insights', desc: 'Up-to-date data for better decisions'},
//     {icon: IconUsers, title: 'Built for Cooperatives', desc: 'Designed around real cooperative workflows'},
//     {icon: IconHeadphones, title: 'Dedicated Support', desc: "We're with you every step of the way"},
//   ];

//   return (
//     <section className="bg-white pv4 bb b--light-gray">
//       <div className=" center ph3">
//         <div className="flex flex-wrap justify-between">
//           {badges.map(badge => {
//             const Icon = badge.icon;
//             return (
//               <div key={badge.title} className="w-100 w-50-m w-20-l pa3 flex items-start">
//                 <Icon className="w1 h1 flex-shrink-0 mt1 mr3" style={{color: EMERALD}} />
//                 <div>
//                   <p className="f6 fw6 dark-gray mb1">{badge.title}</p>
//                   <p className="f7 gray lh-copy">{badge.desc}</p>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// const StorySection = () => {
//   const navigate = useNavigate();

//   return (
//     <section className="bg-white pv5 pv6-l">
//       <div className=" center ph3">
//         <div className="flex flex-wrap items-center">
//           <div className="w-100 w-50-l pr4-l mb4 mb0-l">
//             <div className="flex flex-wrap">
//               <div className="w-50 pr2 mb2">
//                 <div className="br3 overflow-hidden" style={{height: '180px', backgroundColor: EMERALD_LIGHT}}>
//                   <img src="./img/cowgirl.jpeg?w=400&h=300&fit=crop" alt="Farmer with tablet" className="w-100 h-100 object-cover"/>
//                 </div>
//               </div>
//               <div className="w-50 pl2 mb2">
//                 <div className="br3 overflow-hidden" style={{height: '180px', backgroundColor: '#fff7ed'}}>
//                   <img src="./img/coffee bean.jpg?w=400&h=300&fit=crop" alt="Coffee cherries" className="w-100 h-100 object-cover"/>
//                 </div>
//               </div>
//               <div className="w-50 pr2">
//                 <div className="br3 overflow-hidden" style={{height: '180px', backgroundColor: '#f3f4f6'}}>
//                   <img src="./img/milk cans.jpg?w=400&h=300&fit=crop" alt="Milk cans" className="w-100 h-100 object-cover"/>
//                 </div>
//               </div>
//               <div className="w-50 pl2">
//                 <div className="pa3 br3" style={{backgroundColor: EMERALD}}>
//                   <div className="flex items-center mb2">
//                     <div className="w2 h2 br-100 white f7 fw6 flex items-center justify-center mr2" style={{backgroundColor: 'rgba(255,255,255,0.2)'}}>$$</div>
//                   </div>
//                   <p className="white f6 lh-copy">
//                     We exist to simplify operations so cooperatives can thrive.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="w-100 w-50-l pl4-l">
//             <p className="f6 fw6 ttu tracked mb3" style={{color: EMERALD}}>Our Story</p>
//             <h2 className="f2 fw7 dark-gray lh-title mb3">
//               Born from real challenges.<br/>Built for real impact.
//             </h2>
//             <p className="gray f5 lh-copy mb3">
//               We saw hardworking farmers and cooperative leaders struggle with manual records, delayed payments, poor communication, and fragmented data. These challenges slow growth and weaken trust.
//             </p>
//             <p className="gray f5 lh-copy mb3">
//               TerraWeb was created to change that.
//             </p>
//             <p className="gray f5 lh-copy mb4">
//               We are building the digital foundation that helps cooperatives operate smarter, transparently, and sustainably.
//             </p>
//             <button onClick={() => navigate("/")} className="white pv3 ph4 br2 f6 fw5 bn pointer flex items-center" style={{backgroundColor: EMERALD}}>
//               Our Mission <IconArrowRight className="w1 h1 ml2"/>
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const FeaturesSection = () => {
//   const features = [
//     {icon: IconCloudOff, title: 'Collection Management', desc: 'Digitize collection processes for milk, coffee, and more.'},
//     {icon: IconUsers, title: 'Member Management', desc: 'Maintain accurate member records and engagement.'},
//     {icon: IconDollarSign, title: 'Finance & Payouts', desc: 'Automate calculations and payouts with transparency.'},
//     {icon: IconMessageSquare, title: 'Communication', desc: 'Connect members and leaders instantly and effectively.'},
//     {icon: IconTrendingUp, title: 'Reports & Analytics', desc: 'Get insights that drive smarter decisions.'},
//   ];

//   return (
//     <section className="pv5 pv6-l" style={{backgroundColor: '#f9fafb'}}>
//       <div className="center ph3">
//         <div className="tc mb5">
//           <p className="f6 fw6 ttu tracked mb3" style={{color: EMERALD}}>What We Do</p>
//           <h2 className="f2 fw7 dark-gray">All-in-one platform for cooperative success</h2>
//         </div>

//         <div className="flex flex-wrap justify-between">
//           {features.map(f => {
//             const Icon = f.icon;
//             return (
//               <div key={f.title} className="w-100 w-50-m w-20-l pa3">
//                 <div className="bg-white br3 pa4 shadow-1">
//                   <div className="w3 h3 br3 flex items-center justify-center mb3" style={{backgroundColor: EMERALD_LIGHT}}>
//                     <Icon className="w1 h1" style={{color: EMERALD}} />
//                   </div>
//                   <h3 className="f5 fw6 dark-gray mb2">{f.title}</h3>
//                   <p className="f6 gray lh-copy">{f.desc}</p>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// const ValuesSection = () => {
//   const values = [
//     {icon: IconCheckCircle, title: 'Integrity', desc: 'We operate with honesty and transparency.'},
//     {icon: IconZap, title: 'Innovation', desc: 'We build simple, smart solutions that scale.'},
//     {icon: IconClock, title: 'Reliability', desc: 'We deliver systems you can count on every day.'},
//     {icon: IconTarget, title: 'Simplicity', desc: 'We make technology easy and accessible.'},
//     {icon: IconHeartHandshake, title: 'Impact', desc: 'We are committed to empowering communities.'},
//   ];

//   return (
//     <section className="bg-white pv5">
//       <div className=" center ph3">
//         <p className="f6 fw6 ttu tracked mb4 tc" style={{color: EMERALD}}>Our Values</p>
//         <div className="flex flex-wrap justify-between">
//           {values.map(v => {
//             const Icon = v.icon;
//             return (
//               <div key={v.title} className="w-100 w-50-m w-20-l pa3 tc">
//                 <div className="w2 h2 br-100 flex items-center justify-center center mb3" style={{backgroundColor: EMERALD_LIGHT}}>
//                   <Icon className="w1 h1" style={{color: EMERALD}} />
//                 </div>
//                 <h3 className="f5 fw6 dark-gray mb1">{v.title}</h3>
//                 <p className="f6 gray lh-copy">{v.desc}</p>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// const CTABanner = () => {
//   const navigate = useNavigate();
  
//   return (
//     <section className="pv4">
//       <div className="center ph3">
//         <div className="br3 pa4 pa5-l flex flex-wrap items-center justify-between" style={{backgroundColor: DARK_BG}}>
//           <div className="flex items-center w-100 w-70-l mb3 mb0-l">
//             <div className="w3 h3 br-100 flex items-center justify-center flex-shrink-0 mr3" style={{backgroundColor: 'rgba(5,150,105,0.2)'}}>
//               <IconHandshake className="w2 h2" style={{color: '#34d399'}} />
//             </div>
//             <div>
//               <h3 className="f3 fw7 white mb1">Let's build stronger cooperatives together</h3>
//               <p className="white-60 f5">Join organizations already transforming operations with TerraWeb.</p>
//             </div>
//           </div>
//           <div className="w-100 w-30-l flex flex-wrap justify-end-l">
//             <button onClick={() => navigate("/register")} className="white pv3 ph4 br2 f6 fw5 mr3 mb2 mb0-l bn pointer flex items-center" style={{backgroundColor: EMERALD}}>
//               Partner With Us <IconArrowRight className="w1 h1 ml2"/>
//             </button>
//             <button onClick={() => navigate("/contactus")} className="white-80 ba b--white-30 pv3 ph4 br2 f6 fw5 mb2 bn pointer bg-transparent">
//               Contact Sales
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// const WorkTogetherSection = () => {
//   const options = [
//     {href:'https://terraweb.africa/contactus',icon: IconCalendar, color: EMERALD_LIGHT, iconColor: EMERALD, title: 'Request a Demo', desc: 'See how TerraWeb can transform your operations.', cta: 'Book a Demo', ctaColor: EMERALD},
//     {href:'https://terraweb.africa/register',icon: IconUserPlus, color: '#dbeafe', iconColor: '#2563eb', title: 'Become a Pilot Partner', desc: 'Be among our early partners and shape the future together.', cta: 'Join Pilot Program', ctaColor: '#2563eb'},
//     {href:'https://terraweb.africa/contactus',icon: IconHandshake, color: '#f3e8ff', iconColor: '#9333ea', title: 'Partnerships', desc: 'Explore collaboration opportunities with us.', cta: 'Explore Partnerships', ctaColor: '#9333ea'},
//     {href:'https://terraweb.africa/contactus',icon: IconPhone, color: '#ffedd5', iconColor: '#ea580c', title: 'Talk to Sales', desc: 'Speak with our team about your specific needs.', cta: 'Contact Sales', ctaColor: '#ea580c'},
//   ];

//   return (
//     <section className="bg-white pv5 pv6-l">
//       <div className=" center ph3">
//         <div className="tc mb5">
//           <h2 className="f2 fw7 dark-gray mb2">How we can work together</h2>
//           <p className="gray f5">Choose the path that fits your organization.</p>
//         </div>

//         <div className="flex flex-wrap justify-between">
//           {options.map(opt => {
//             const Icon = opt.icon;
//             return (
//               <div key={opt.title} className="w-100 w-50-m w-25-l pa3">
//                 <div className="pa4 br3" style={{backgroundColor: '#f9fafb'}}>
//                   <div className="w3 h3 br3 flex items-center justify-center mb3" style={{backgroundColor: opt.color}}>
//                     <Icon className="w1 h1" style={{color: opt.iconColor}} />
//                   </div>
//                   <h3 className="f5 fw6 dark-gray mb2">{opt.title}</h3>
//                   <p className="f6 gray lh-copy mb3">{opt.desc}</p>
//                   <a href={opt.href} className="link f6 fw5 flex items-center" style={{color: opt.ctaColor}}>
//                     {opt.cta} <IconArrowRight className="w1 h1 ml1"/>
//                   </a>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </section>
//   );
// };

// // const Footer = () => {
// //   return (
// //     <footer className="pv5" style={{backgroundColor: DARK_BG}}>
// //       <div className="mw8 center ph3">
// //         <div className="flex flex-wrap justify-between mb4">
// //           <div className="w-100 w-30-l mb4 mb0-l">
// //             <div className="flex items-center mb3">
// //               <div className="w2 h2 br2 flex items-center justify-center mr2" style={{backgroundColor: EMERALD}}>
// //                 <svg viewBox="0 0 24 24" className="w1 h1 white" fill="currentColor">
// //                   <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
// //                 </svg>
// //               </div>
// //               <span className="f4 fw6 white">TerraWeb</span>
// //             </div>
// //             <p className="white-60 f6 lh-copy">
// //               Building digital infrastructure for stronger agricultural cooperatives across Africa.
// //             </p>
// //           </div>
// //           <div className="w-100 w-60-l flex flex-wrap justify-between">
// //             {[
// //               {title: 'Product', links: ['Platform', 'Solutions', 'Pricing', 'Security']},
// //               {title: 'Company', links: ['About Us', 'Careers', 'Blog', 'Press']},
// //               {title: 'Resources', links: ['Documentation', 'Help Center', 'Community', 'Status']},
// //               {title: 'Legal', links: ['Privacy', 'Terms', 'Cookies']}
// //             ].map(col => (
// //               <div key={col.title} className="w-50 w-25-ns mb3">
// //                 <h4 className="f6 fw6 white mb3">{col.title}</h4>
// //                 {col.links.map(link => (
// //                   <a key={link} href="#" className="db link white-60 f6 mb2 hover-white">{link}</a>
// //                 ))}
// //               </div>
// //             ))}
// //           </div>
// //         </div>
// //         <div className="pt4 bt b--white-10">
// //           <p className="white-40 f7 tc">© 2026 TerraWeb. All rights reserved.</p>
// //         </div>
// //       </div>
// //     </footer>
// //   );
// // };

// // --- Main App ---

// export default function Services() {
//   return (

//     <>
//     <TerraWebPage/>
//        <div className="min-h-100 bg-white">
//     {/* <div className="min-h-100 bg-white"> */}
//       {/* <Navbar/> */}
//       <HeroSection/>
//       <TrustBadges/>
//       <StorySection/>
//       <FeaturesSection/>
//       <ValuesSection/>
//       <CTABanner/>
//       <WorkTogetherSection/>
//       {/* <Footer/> */}
//     </div>
//     </>
 
//   );
// }

// // new serviceswith bwtter content
import React from "react";
import { Icon } from "./icons.js";
import "./styles.css";
import { HeroStats, HeroDashboard } from "./Herostatcards.js";
// import "./Herostatcards.css"


const NAV_LINKS = ["Home", "About Us", "Services", "Features", "Pricing", "Resources", "Contact"];

const STRIP_ITEMS = [
  { icon: "users", label: "Built for Cooperatives" },
  { icon: "cloud", label: "Secure Cloud Platform" },
  { icon: "chart", label: "Real-Time Reporting" },
  { icon: "person", label: "Farmer Centred" },
  { icon: "monitor", label: "Easy to Use Anywhere" },
  { icon: "headset", label: "Reliable Support Always" },
];

const SOLUTIONS = [
  { icon: "users", color: "var(--tw-green)", title: "Farmer Management", desc: "Create and manage digital profiles for every member. Keep records accurate, updated and easily accessible.", bullets: ["Digital farmer profiles", "Member registration", "Production history", "Fast record search", "Accurate member database"] },
  { icon: "droplet", color: "var(--tw-blue)", title: "Milk Collection", desc: "Record milk deliveries accurately at every collection centre. Improve transparency and get real-time insights.", bullets: ["Digital milk recording", "Daily production tracking", "Centre performance", "Automated summaries", "Real-time insights"] },
  { icon: "coffee", color: "var(--tw-brown)", title: "Coffee Collection", desc: "Manage coffee deliveries efficiently during every season with complete visibility and reliable records.", bullets: ["Coffee delivery management", "Seasonal tracking", "Harvest records", "Delivery verification", "Performance reporting"] },
  { icon: "folder", color: "var(--tw-purple)", title: "Digital Records", desc: "Store all cooperative records securely in the cloud and retrieve them in seconds anytime, anywhere.", bullets: ["Centralized records", "Secure cloud storage", "Instant retrieval", "Document management", "Historical archive"] },
  { icon: "chart", color: "var(--tw-orange)", title: "Reporting & Analytics", desc: "Turn your data into meaningful reports and dashboards that support better planning and stronger decisions.", bullets: ["Real-time dashboards", "Production reports", "Performance analytics", "Trend monitoring", "Decision support"] },
  { icon: "message", color: "var(--tw-teal)", title: "Communication", desc: "Reach all members instantly with announcements, updates and important messages that matter.", bullets: ["Member notifications", "Announcements", "Operational updates", "Meeting alerts", "Better engagement"] },
  { icon: "monitor", color: "var(--tw-navy)", title: "Executive Dashboard", desc: "A complete overview of your cooperative's performance at a glance for managers and board members.", bullets: ["Executive overview", "Key performance indicators", "Collection summaries", "Member statistics", "Strategic monitoring"] },
  { icon: "cloud", color: "var(--tw-green)", title: "Secure Cloud", desc: "Your data is protected with enterprise-grade security, regular backups and controlled access.", bullets: ["Secure infrastructure", "Role-based access", "Automatic backups", "Data encryption", "Disaster recovery"] },
  { icon: "portal", color: "var(--tw-pink)", title: "Farmer Self-Service Portal", desc: "Empower farmers to access their own information and production history anytime through a simple portal.", bullets: ["View production history", "Digital statements", "Personal information", "Transparency", "Self-service access"] },
  { icon: "route", color: "var(--tw-orange)", title: "Route & Centre Management", desc: "Organize routes, manage collection centres and monitor field operations for better coordination.", bullets: ["Route planning", "Centre management", "Collector assignments", "Route performance", "Field monitoring"] },
  { icon: "staff", color: "var(--tw-blue)", title: "User & Staff Management", desc: "Manage staff accounts, roles and permissions to ensure accountability and proper access control.", bullets: ["User accounts", "Role management", "Permissions control", "Activity tracking", "Accountability"] },
  { icon: "wrench", color: "var(--tw-green)", title: "Support & Maintenance", desc: "Get reliable support whenever you need it and keep your operations running smoothly all year round.", bullets: ["Technical support", "System maintenance", "Product updates", "Issue resolution", "Dedicated team"] },
  { icon: "grad", color: "var(--tw-purple)", title: "Training & Onboarding", desc: "We train your team to ensure a smooth adoption and help your cooperative get the most out of TerraWeb.", bullets: ["User training", "Practical guides", "Onboarding support", "Continuous learning", "Adoption success"] },
  { icon: "migrate", color: "var(--tw-teal)", title: "Data Migration & Integration", desc: "Move your existing records safely into TerraWeb and integrate with other systems with ease.", bullets: ["Data migration", "System integration", "Legacy data import", "Clean data setup", "Seamless transition"] },
  { icon: "plug", color: "var(--tw-gold)", title: "API & Integrations", desc: "Connect TerraWeb with third-party systems and tools to extend functionality and improve efficiency.", bullets: ["API access", "Third-party integrations", "Data synchronization", "Workflow automation", "Enhanced connectivity"] },
  { icon: "bell", color: "var(--tw-blue)", title: "SMS & Notifications", desc: "Automated SMS alerts keep members informed about deliveries, statements and important updates.", bullets: ["SMS alerts", "Delivery notifications", "Statement notifications", "Payment reminders", "Instant updates"] },
];

const STEPS = [
  { icon: "search", color: "var(--tw-green)", title: "Discover", desc: "We understand your cooperative, its challenges and goals." },
  { icon: "gear", color: "var(--tw-orange)", title: "Configure", desc: "We customize TerraWeb to match your workflows and requirements." },
  { icon: "database", color: "var(--tw-blue)", title: "Migrate Data", desc: "We securely organize and import your existing records." },
  { icon: "grad", color: "var(--tw-purple)", title: "Train Staff", desc: "Your team receives practical training and ongoing guidance." },
  { icon: "flag", color: "var(--tw-green)", title: "Go Live", desc: "We launch together and your cooperative starts operating digitally." },
  { icon: "headset", color: "var(--tw-orange)", title: "Continuous Support", desc: "We stay with you for long-term success and growth." },
];

const WHY = [
  { icon: "flag", title: "Purpose Built", desc: "Designed specifically for agriculture and cooperatives." },
  { icon: "person", title: "Simple & Easy", desc: "Intuitive interface that your entire team can use." },
  { icon: "lock", title: "Reliable & Secure", desc: "Your data is protected with industry-leading security." },
  { icon: "chart", title: "Scalable", desc: "Grows with your cooperative today and tomorrow." },
  { icon: "trophy", title: "Proven Impact", desc: "Helping cooperatives improve efficiency and member trust." },
];

const FOOTER_STRIP = [
  { icon: "trophy", label: "Used by 100+ Cooperatives" },
  { icon: "shield", label: "99.9% Platform Uptime" },
  { icon: "lock", label: "Bank-Level Security" },
  { icon: "flag", label: "Support Across Kenya" },
];

function Button({ variant = "primary", children, ...rest }) {
  const cls = variant === "primary" ? "tw-btn tw-btn-primary" : variant === "outline" ? "tw-btn tw-btn-outline" : "tw-btn tw-btn-dark-outline";
  return <a href="/contactus" className={cls} {...rest}>{children}</a>;
}

function SectionHeader({ eyebrow, title, sub }) {
  return (
    <div className="tc mb4">
      {eyebrow && <div className="tw-eyebrow mb2">{eyebrow}</div>}
      <h2 className="tw-h2 ma0">{title}</h2>
      {sub && <p className="f6 gray mt2 mb0">{sub}</p>}
      <div className="tw-rule" />
    </div>
  );
}

function SolutionCard({ icon, color, title, desc, bullets }) {
  return (
    <div className="tw-card">
      <div className="tw-icon-circle mb3" style={{ background: color }}>
        <Icon name={icon} size={20} />
      </div>
      <h3>{title}</h3>
      <p className="desc">{desc}</p>
      <ul className="tw-bullets">
        {bullets.map((b) => (
          <li key={b}>
            <span style={{ color }}><Icon name="check" /></span>
            {b}
          </li>
        ))}
      </ul>
      <a href="/register" className="tw-learn">Learn more <Icon name="arrow" /></a>
    </div>
  );
}

export default function TerraWebPage() {
  return (
    <div className="sans-serif">
      {/* ---------------- Navbar ---------------- */}
      <header className="tw-bg-dark w-100">
        <div className="mw9 center flex items-center justify-between pa3 ph4-l">
          <div className="flex items-center white f4 fw8">
            <span className="tw-orange mr2">◆</span>TerraWeb
          </div>
          <nav className="tw-nav-links dn flex-l items-center" style={{ gap: "1.6rem" }}>
            {NAV_LINKS.map((l) => (
              <a key={l} href="#" className={`tw-nav-link ${l === "Services" ? "active" : ""}`}>{l.toUpperCase()}</a>
            ))}
          </nav>
          <Button variant="primary">BOOK A LIVE DEMO</Button>
        </div>
      </header>

      {/* ---------------- Hero ---------------- */}
      <section className="tw-hero pv5 ph3 ph4-l">
        <div className="mw9 center">
          <div className="tw-hero-grid grid" style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: "2.5rem", alignItems: "center" }}>
            <div>
              <div className="tw-eyebrow mb3">OUR SERVICES</div>
              <h1 className="white f2 f1-l fw8 lh-title ma0">
                Digital Solutions.<br />
                Stronger Cooperatives.<br />
                <span className="tw-orange">Better Futures.</span>
              </h1>
              <p className="f6 mt3" style={{ color: "#c7c7bd", maxWidth: 460 }}>
                TerraWeb empowers agricultural cooperatives with simple, powerful digital tools to manage operations, engage members and make smarter decisions through reliable data.
              </p>
              <div className="flex flex-wrap mt4" style={{ gap: ".8rem" }}>
                <Button variant="primary">BOOK A LIVE DEMO <Icon name="arrow" /></Button>
                <Button variant="outline"><Icon name="play" /> EXPLORE PLATFORM</Button>
              </div>
              <div className="flex items-center mt4" style={{ gap: ".7rem" }}>
                <div className="flex">
                  {["#d97757", "#3a8a4a", "#2f6fd6", "#d6a72e"].map((c) => (
                    <span key={c} className="tw-avatar" style={{ background: c }} />
                  ))}
                </div>
                <div>
                  <div className="flex" style={{ color: "#f0b429" }}>
                    {[1, 2, 3, 4, 5].map((i) => <Icon key={i} name="star" />)}
                  </div>
                  <div className="f7" style={{ color: "#a9a9a1" }}>4.9/5 from 120+ cooperatives</div>
                </div>
              </div>
            </div>

<div className="tw-hero-media">
  <div className="tw-hero-photo" style={{ backgroundImage: "url('./img/cowgirl.jpeg')" }} />
 {/* <img src="./img/cowgirl.jpeg?w=400&h=300&fit=crop" alt="Farmer with tablet" className="w-100 h-100 object-cover"/> */}
  
  <HeroStats />
  <HeroDashboard />
</div>
            
          </div>
        </div>
      </section>

      {/* ---------------- Feature strip ---------------- */}
      <section className="tw-strip pv3 ph3 ph4-l">
        <div className="mw9 center tw-strip-grid" style={{ display: "grid", gridTemplateColumns: "repeat(6,1fr)", gap: "1rem" }}>
          {STRIP_ITEMS.map((s) => (
            <div key={s.label} className="flex items-center" style={{ gap: ".6rem" }}>
              <span className="tw-strip-icon"><Icon name={s.icon} size={16} /></span>
              <span className="tw-strip-item">{s.label}</span>
            </div>
          ))}
        </div>
      </section>

      {/* ---------------- Solutions grid ---------------- */}
      <section className="pv5 ph3 ph4-l">
        <div className="mw9 center">
          <SectionHeader eyebrow={null} title={<>POWERFUL <span className="tw-orange">SOLUTIONS</span> FOR EVERY PART OF YOUR COOPERATIVE</>} sub="Everything you need. All in one Platform." />
          <div className="tw-solutions-grid">
            {SOLUTIONS.map((s) => <SolutionCard key={s.title} {...s} />)}
          </div>
        </div>
      </section>

      {/* ---------------- How we work ---------------- */}
      <section className="pv5 ph3 ph4-l" style={{ background: "#faf9f6" }}>
        <div className="mw9 center">
          <SectionHeader title="HOW WE WORK WITH YOU" />
          <div className="tw-timeline">
            {STEPS.map((s, i) => (
              <div className="tw-timeline-step" key={s.title}>
                <div className="tw-timeline-num" style={{ background: s.color }}>{i + 1}</div>
                <div className="tw-timeline-title">{s.title}</div>
                <div className="tw-timeline-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ---------------- Why choose ---------------- */}
      <section className="pv5 ph3 ph4-l">
        <div className="mw9 center grid" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "2.5rem", alignItems: "center" }}>
          <div>
            <h2 className="f4 fw8 mb4">WHY COOPERATIVES CHOOSE TERRAWEB</h2>
            <div className="tw-why-grid" style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", gap: "1rem" }}>
              {WHY.map((w) => (
                <div className="tw-why-item" key={w.title}>
                  <div className="tw-why-icon"><Icon name={w.icon} size={20} /></div>
                  <div className="tw-why-title">{w.title}</div>
                  <div className="tw-why-desc">{w.desc}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="relative">
            {/* <div className="br2" style={{ height: 260, background: "linear-gradient(160deg,#3a4a35,#23281e)" }} /> */}
  <div className="tw-hero-photo" style={{ backgroundImage: "url('./img/cowgirl.jpeg')" }} />
            <div className="absolute" style={{ bottom: "-20px", right: "-10px", width: "62%" }}>
              <div className="tw-testimonial">
                <p className="mb2">"TerraWeb has transformed the way we work. Our records are accurate, reports are instant and our members trust us more."</p>
                <div className="name">— John Maina</div>
                <div className="f7 gray">Manager, Kangema Dairy Cooperative</div>
                <div className="tw-dots mt3">
                  <span className="active" /><span /><span />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------------- CTA ---------------- */}
      <section className="tw-cta pv4 ph3 ph4-l">
        <div className="mw9 center flex flex-wrap items-center justify-between" style={{ gap: "1rem" }}>
          <div>
            <div className="white f4 fw8">Ready to Build a <span className="tw-orange">Smarter Cooperative?</span></div>
            <div className="f6 mt1" style={{ color: "#c7c7bd" }}>Join forward-thinking cooperatives using TerraWeb to save time, improve transparency and grow sustainably.</div>
          </div>
          <div className="flex" style={{ gap: ".8rem" }}>
            <Button variant="primary"><Icon name="calendar" size={14} /> BOOK A LIVE DEMO</Button>
            <Button variant="outline"><Icon name="phone" size={14} /> CONTACT US</Button>
          </div>
        </div>
      </section>

      {/* ---------------- Footer strip ---------------- */}
      <section className="tw-footer-strip pv3 ph3 ph4-l">
        <div className="mw9 center flex flex-wrap items-center justify-center" style={{ gap: "2rem" }}>
          {FOOTER_STRIP.map((f) => (
            <div key={f.label} className="flex items-center" style={{ gap: ".5rem" }}>
              <span className="tw-orange"><Icon name={f.icon} size={16} /></span>
              <span className="tw-footer-strip-item">{f.label}</span>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}